import { render, staticRenderFns } from "./DictPositionMvdSalaryListPage.vue?vue&type=template&id=746b514a&"
import script from "./DictPositionMvdSalaryListPage.vue?vue&type=script&lang=ts&"
export * from "./DictPositionMvdSalaryListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports